/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Login_Offline_Activation_Failed_With_ErrorInputs */

const en_login_offline_activation_failed_with_error = /** @type {(inputs: Login_Offline_Activation_Failed_With_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Activation Failed. ${i?.message}`)
};

const fr_login_offline_activation_failed_with_error = /** @type {(inputs: Login_Offline_Activation_Failed_With_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Activation echouee. ${i?.message}`)
};

const de_login_offline_activation_failed_with_error = /** @type {(inputs: Login_Offline_Activation_Failed_With_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktivierung fehlgeschlagen. ${i?.message}`)
};

const it_login_offline_activation_failed_with_error = /** @type {(inputs: Login_Offline_Activation_Failed_With_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Attivazione fallita. ${i?.message}`)
};

const ru_login_offline_activation_failed_with_error = /** @type {(inputs: Login_Offline_Activation_Failed_With_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Активация не удалась. ${i?.message}`)
};

const es_login_offline_activation_failed_with_error = /** @type {(inputs: Login_Offline_Activation_Failed_With_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Activación fallida. ${i?.message}`)
};

const zh_cn2_login_offline_activation_failed_with_error = /** @type {(inputs: Login_Offline_Activation_Failed_With_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`激活失败。${i?.message}`)
};

const ja_login_offline_activation_failed_with_error = /** @type {(inputs: Login_Offline_Activation_Failed_With_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`アクティベーションに失敗しました。${i?.message}`)
};

const hi_login_offline_activation_failed_with_error = /** @type {(inputs: Login_Offline_Activation_Failed_With_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`सक्रियण विफल। ${i?.message}`)
};

const pt_pt2_login_offline_activation_failed_with_error = /** @type {(inputs: Login_Offline_Activation_Failed_With_ErrorInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A ativação falhou. ${i?.message}`)
};

/**
* | output |
* | --- |
* | "Activation Failed. {message}" |
*
* @param {Login_Offline_Activation_Failed_With_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_activation_failed_with_error = /** @type {((inputs: Login_Offline_Activation_Failed_With_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Activation_Failed_With_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_offline_activation_failed_with_error(inputs)
	if (locale === "de") return de_login_offline_activation_failed_with_error(inputs)
	if (locale === "it") return it_login_offline_activation_failed_with_error(inputs)
	if (locale === "ru") return ru_login_offline_activation_failed_with_error(inputs)
	if (locale === "es") return es_login_offline_activation_failed_with_error(inputs)
	if (locale === "zh-CN") return zh_cn2_login_offline_activation_failed_with_error(inputs)
	if (locale === "ja") return ja_login_offline_activation_failed_with_error(inputs)
	if (locale === "hi") return hi_login_offline_activation_failed_with_error(inputs)
	if (locale === "pt-PT") return pt_pt2_login_offline_activation_failed_with_error(inputs)
	return en_login_offline_activation_failed_with_error(inputs)
});